import { Checkbox, Form } from 'antd';
import { CompanyType } from 'core/client';
import { useTranslation } from 'react-i18next';
import { CompanyBaseSelect } from 'src/components/Form/CompanyBaseSelect';
import { MoneyInput } from 'src/components/Form/MoneyInput';
import { TaskAppraisalTypeSelect } from 'src/components/Form/TaskAppraisalTypeSelect';
import { ReportRateSelect } from 'src/components/Rates/Form/ReportRateSelect';
import styled from 'styled-components';
import { CompanySelect } from '../../../Form/CompanySelect';
import { ZoneSelect } from '../../../Form/ZoneSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Content fields for report tasks */
export var TaskFormContentReport = function TaskFormContentReport(_ref) {
  var canEdit = _ref.canEdit,
      isReadonly = _ref.isReadonly;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isDisabled = !canEdit || isReadonly;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Form.Item, {
      name: ['content', 'companyId'],
      label: t('form.task.company.label'),
      rules: isDisabled ? undefined : [{
        required: true,
        message: t('form.task.company.error.required')
      }],
      children: /*#__PURE__*/_jsx(CompanySelect, {
        type: CompanyType.Insurance,
        isReadonly: isDisabled
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      noStyle: true,
      shouldUpdate: true,
      children: function children(form) {
        return /*#__PURE__*/_jsx(Form.Item, {
          name: ['content', 'baseId'],
          label: t('form.task.base.label'),
          rules: isDisabled ? undefined : [{
            required: true,
            message: t('form.task.base.error.required')
          }],
          children: /*#__PURE__*/_jsx(CompanyBaseSelect, {
            companyId: form.getFieldValue(['content', 'companyId']),
            isReadonly: isDisabled
          })
        });
      }
    }), /*#__PURE__*/_jsx(Form.Item, {
      name: ['content', 'zoneId'],
      label: t('form.task.zone.label'),
      rules: isDisabled ? undefined : [{
        required: true,
        message: t('form.task.zone.error.required')
      }],
      children: /*#__PURE__*/_jsx(ZoneSelect, {
        isReadonly: isDisabled
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      name: ['content', 'rate'],
      label: t('form.task.rate.label'),
      rules: isDisabled ? undefined : [{
        required: true,
        message: t('form.task.rate.error.required')
      }],
      children: /*#__PURE__*/_jsx(ReportRateSelect, {
        onlyActive: true,
        placeholder: t('form.task.rate.placeholder'),
        isReadonly: isDisabled
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      name: ['content', 'appraisalType'],
      label: t('form.task.appraisalType.label'),
      rules: isDisabled ? undefined : [{
        required: true,
        message: t('form.task.appraisalType.error.required')
      }],
      children: /*#__PURE__*/_jsx(TaskAppraisalTypeSelect, {
        placeholder: t('form.task.appraisalType.placeholder'),
        emptyMessage: t('form.task.appraisalType.empty'),
        isReadonly: isDisabled
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      name: ['content', 'price'],
      label: t('form.task.price.label'),
      children: /*#__PURE__*/_jsx(MoneyInput, {
        placeholder: t('form.task.price.placeholder'),
        isReadonly: isDisabled,
        emptyMessage: t('form.task.appraisalType.empty')
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      name: ['content', 'isFraud'],
      valuePropName: "checked",
      label: t('form.task.isFraud.label'),
      children: /*#__PURE__*/_jsx(Checkbox, {
        disabled: isReadonly
      })
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Report__Container",
  componentId: "sc-1onlmcc-0"
})([""]);